export default "__VITE_ASSET__D38M6JOX__"